"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioManager = void 0;
var GameVars_1 = require("./GameVars");
var GameManager_1 = require("./GameManager");
// audiosprite -e "mp3,ogg" -o ../assets/audio/audiosprite *.mp3 -f howler -b 96
var AudioManager = /** @class */ (function () {
    function AudioManager() {
    }
    AudioManager.init = function () {
        AudioManager.howl.mute(GameVars_1.GameVars.gameData.muted);
        AudioManager.rate = 1;
        AudioManager.lastSoundPlayed = null;
        AudioManager.loopID = null;
    };
    AudioManager.toggleAudioState = function () {
        GameVars_1.GameVars.gameData.muted = !GameVars_1.GameVars.gameData.muted;
        GameManager_1.GameManager.writeGameData();
        AudioManager.howl.mute(GameVars_1.GameVars.gameData.muted);
    };
    AudioManager.mute = function () {
        if (AudioManager.howl === null) {
            return;
        }
        AudioManager.howl.mute(true);
    };
    AudioManager.unmute = function () {
        if (AudioManager.howl === null) {
            return;
        }
        if (!GameVars_1.GameVars.gameData.muted) {
            AudioManager.howl.mute(false);
        }
    };
    AudioManager.playSound = function (key, loop, volume, rate) {
        var t = new Date().getTime();
        if (t - AudioManager.timeLastEffectPlayed < 100 && AudioManager.lastSoundPlayed === key) {
            return;
        }
        AudioManager.timeLastEffectPlayed = t;
        AudioManager.lastSoundPlayed = key;
        loop = loop || false;
        volume = volume || 1;
        var id = AudioManager.howl.play(key);
        AudioManager.howl.volume(volume, id);
        if (loop) {
            if (AudioManager.loopID) {
                AudioManager.howl.stop(AudioManager.loopID);
            }
            AudioManager.loopID = id;
            AudioManager.rate = 1;
            AudioManager.howl.loop(true, AudioManager.loopID);
        }
        if (rate) {
            AudioManager.howl.rate(rate, id);
        }
        return id;
    };
    AudioManager.stopSound = function (id) {
        AudioManager.howl.stop(id);
    };
    AudioManager.setLoopVolume = function (v) {
        AudioManager.howl.volume(v);
    };
    AudioManager.stopLoop = function (loopID) {
        var id = AudioManager.loopID || loopID;
        if (id) {
            AudioManager.howl.stop(id);
        }
    };
    AudioManager.increaseLoopRate = function () {
        if (AudioManager.rate >= 1.75) {
            return;
        }
        AudioManager.rate += .01;
        AudioManager.howl.rate(AudioManager.rate, AudioManager.loopID);
    };
    AudioManager.onBlur = function () {
        if (!GameVars_1.GameVars.gameData.muted && AudioManager.howl) {
            AudioManager.howl.mute(true);
        }
    };
    AudioManager.onFocus = function () {
        if (!GameVars_1.GameVars.gameData.muted && AudioManager.howl) {
            AudioManager.howl.mute(false);
        }
    };
    AudioManager.howl = null;
    return AudioManager;
}());
exports.AudioManager = AudioManager;
